:host {
  display: block;
}

.spw-list-item {
  @apply spw-tw-mb-10;
  &:last-child {
    @apply spw-tw-mb-0;
  }

  &:hover {
    .spw-list-item__title {
      color: var(--spw-ds-primary);
    }
  }

  a {
    display: block;
    color: inherit;
    text-decoration: none;
    &:focus-visible {
      outline: 3px solid var(--spw-ds-focus);
    }
  }

  &__title {
    position: relative;
    color: var(--spw-color-themes-grey-grey-900);
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
    transition: all 0.3s;
    &:before {
      font-family: 'Font Awesome 6 Free';
      font-weight: 700;
      content: '\f061';
      font-size: 1.25rem;
      margin-right: 0.5rem;
      color: var(--spw-ds-primary);
      left: 0;
    }
  }

  &__text {
    color: var(--spw-color-themes-grey-grey-600);
    font-size: 16px;
    line-height: 1.3;
    @apply spw-tw-mt-2;
  }
}

.spw-results {
  color: var(--spw-color-themes-grey-grey-600);
  @apply spw-tw-mb-10;
}

.spw-no-results {
  &__title {
    margin-bottom: 16px;
    color: var(--spw-color-themes-grey-grey-900);
    font-weight: 600;
  }
  &__list {
    padding-left: 20px;
    list-style-type: disc;
    color: var(--spw-color-themes-grey-grey-600);
    li {
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.spw-search-input {
  @apply spw-tw-mb-6;
  width: 100%;
  max-width: 480px;
  position: relative;
}
